import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { getSlates } from '../services/games-service.service.api';
import type { Slate } from '../interfaces/slates.interface';

function useSlates(
  scheduleId?: string,
  options?: Omit<UseQueryOptions<Slate[]>, 'queryKey' | 'queryFn'>
) {
  return useQuery({
    ...options,
    queryKey: ['contestSlates', scheduleId],
    queryFn: () => getSlates(scheduleId),
    enabled: !!scheduleId && (options?.enabled ?? true),
  });
}

export default useSlates;
